var window=global;var $CLJS=require("./cljs_env.js");
'use strict';var Ega=require("moment-timezone");module.exports=Ega;